import Slider from "react-slick";
import "../styles/heroSection.css";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const HeroSection = () => {
  const { blogListArray } = useAuth();
  // const 
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getPlainText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
};



  return (
    <div className="carousel-container poppins-medium">
      <Slider {...settings}>
        {blogListArray.map((blogItem) => (
          <div key={blogItem._id} className="carousel-slide"  >
            <Link to={blogItem.slug} onClick={()=>{
                  window.scrollTo(0, 0);
                }}>
              <div className="slide-content">
                <img
                  src={blogItem.imageUrl}
                  alt={blogItem.title}
                  className="carousel-image"
                />
                <div className="slide-text">
                  <h2 className="slide-title-hs">{blogItem.title}</h2>
                  <p className="slide-text-hs">
                    { getPlainText(blogItem.content).split(" ").slice(0, 20).join(" ")}...
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroSection;
